const CARTO_BASE_URL =
  "https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png";

export function getCartoTileUrl() {
  const key =
    typeof window !== "undefined" &&
    window.env &&
    window.env.CARTO_API_KEY
      ? window.env.CARTO_API_KEY
      : "";
  return key ? `${CARTO_BASE_URL}?key=${key}` : CARTO_BASE_URL;
}

export default getCartoTileUrl;
